<span class="description">
  {{ 'AUTOMATIONS.EDITOR.TRIGGERS.PARTNER_SUBSCRIPTION_TIER_UPDATE.PARTNER_SUBSCRIPTION_TIER_CHANGE' | translate }}
</span>
<glxy-form-field>
  <glxy-label>
    {{ 'AUTOMATIONS.EDITOR.TRIGGERS.PARTNER_SUBSCRIPTION_TIER_UPDATE.CHANGE_TYPE_FORM.TITLE' | translate }}
  </glxy-label>
  <mat-select [(value)]="updateType">
    <mat-option value="*">
      {{ 'AUTOMATIONS.EDITOR.TRIGGERS.PARTNER_SUBSCRIPTION_TIER_UPDATE.CHANGE_TYPE_FORM.ANY' | translate }}
    </mat-option>
    <mat-option [value]="updateTypeEnum.FreeToPaid">
      {{ 'AUTOMATIONS.EDITOR.TRIGGERS.PARTNER_SUBSCRIPTION_TIER_UPDATE.CHANGE_TYPE_FORM.FREE_TO_PAID' | translate }}
    </mat-option>
    <mat-option [value]="updateTypeEnum.PaidToPaid">
      {{ 'AUTOMATIONS.EDITOR.TRIGGERS.PARTNER_SUBSCRIPTION_TIER_UPDATE.CHANGE_TYPE_FORM.PAID_TO_PAID' | translate }}
    </mat-option>
    <mat-option [value]="updateTypeEnum.SwitchFreeTrial">
      {{
        'AUTOMATIONS.EDITOR.TRIGGERS.PARTNER_SUBSCRIPTION_TIER_UPDATE.CHANGE_TYPE_FORM.SWITCH_FREE_TRIAL' | translate
      }}
    </mat-option>
    <mat-option [value]="updateTypeEnum.CancelFreeTrial">
      {{
        'AUTOMATIONS.EDITOR.TRIGGERS.PARTNER_SUBSCRIPTION_TIER_UPDATE.CHANGE_TYPE_FORM.CANCEL_FREE_TRIAL' | translate
      }}
    </mat-option>
    <mat-option [value]="updateTypeEnum.CancelFreeTrialFailedPayment">
      {{
        'AUTOMATIONS.EDITOR.TRIGGERS.PARTNER_SUBSCRIPTION_TIER_UPDATE.CHANGE_TYPE_FORM.CANCEL_FREE_TRIAL_FAILED_PAYMENT'
          | translate
      }}
    </mat-option>
    <mat-option [value]="updateTypeEnum.FreeToFreeTrial">
      {{
        'AUTOMATIONS.EDITOR.TRIGGERS.PARTNER_SUBSCRIPTION_TIER_UPDATE.CHANGE_TYPE_FORM.FREE_TO_FREE_TRIAL' | translate
      }}
    </mat-option>
  </mat-select>
</glxy-form-field>

<glxy-form-field>
  <glxy-label>
    {{ 'AUTOMATIONS.EDITOR.TRIGGERS.PARTNER_SUBSCRIPTION_TIER_UPDATE.FROM_TIER_FORM.TITLE' | translate }}
  </glxy-label>
  <mat-select [(value)]="fromSubscriptionTier">
    <mat-option value="*">
      {{ 'AUTOMATIONS.EDITOR.TRIGGERS.PARTNER_SUBSCRIPTION_TIER_UPDATE.FROM_TIER_FORM.ANY' | translate }}
    </mat-option>
    <mat-option *ngFor="let tier of subscriptionTierOptions$ | async" [value]="tier.value">
      {{ tier.name }}
    </mat-option>
  </mat-select>
</glxy-form-field>

<glxy-form-field>
  <glxy-label>
    {{ 'AUTOMATIONS.EDITOR.TRIGGERS.PARTNER_SUBSCRIPTION_TIER_UPDATE.TO_TIER_FORM.TITLE' | translate }}
  </glxy-label>
  <mat-select [(value)]="toSubscriptionTier">
    <mat-option value="*">
      {{ 'AUTOMATIONS.EDITOR.TRIGGERS.PARTNER_SUBSCRIPTION_TIER_UPDATE.TO_TIER_FORM.ANY' | translate }}
    </mat-option>
    <mat-option *ngFor="let tier of subscriptionTierOptions$ | async" [value]="tier.value">
      {{ tier.name }}
    </mat-option>
  </mat-select>
</glxy-form-field>

<glxy-form-field>
  <glxy-label>
    {{ 'AUTOMATIONS.EDITOR.TRIGGERS.PARTNER_SUBSCRIPTION_TIER_UPDATE.TO_BILLING_FREQUENCY_FORM.TITLE' | translate }}
  </glxy-label>
  <mat-select [(value)]="toBillingFrequency">
    <mat-option value="*">
      {{ 'AUTOMATIONS.EDITOR.TRIGGERS.PARTNER_SUBSCRIPTION_TIER_UPDATE.TO_BILLING_FREQUENCY_FORM.ANY' | translate }}
    </mat-option>
    <mat-option [value]="billingFrequencyEnum.Monthly">
      {{ 'AUTOMATIONS.EDITOR.TRIGGERS.PARTNER_SUBSCRIPTION_TIER_UPDATE.TO_BILLING_FREQUENCY_FORM.MONTHLY' | translate }}
    </mat-option>
    <mat-option [value]="billingFrequencyEnum.Yearly">
      {{ 'AUTOMATIONS.EDITOR.TRIGGERS.PARTNER_SUBSCRIPTION_TIER_UPDATE.TO_BILLING_FREQUENCY_FORM.YEARLY' | translate }}
    </mat-option>
  </mat-select>
</glxy-form-field>

<glxy-form-field>
  <glxy-label>
    {{ 'AUTOMATIONS.EDITOR.TRIGGERS.PARTNER_SUBSCRIPTION_TIER_UPDATE.FROM_BILLING_FREQUENCY_FORM.TITLE' | translate }}
  </glxy-label>
  <mat-select [(value)]="fromBillingFrequency">
    <mat-option value="*">
      {{ 'AUTOMATIONS.EDITOR.TRIGGERS.PARTNER_SUBSCRIPTION_TIER_UPDATE.TO_BILLING_FREQUENCY_FORM.ANY' | translate }}
    </mat-option>
    <mat-option [value]="billingFrequencyEnum.Monthly">
      {{ 'AUTOMATIONS.EDITOR.TRIGGERS.PARTNER_SUBSCRIPTION_TIER_UPDATE.TO_BILLING_FREQUENCY_FORM.MONTHLY' | translate }}
    </mat-option>
    <mat-option [value]="billingFrequencyEnum.Yearly">
      {{ 'AUTOMATIONS.EDITOR.TRIGGERS.PARTNER_SUBSCRIPTION_TIER_UPDATE.TO_BILLING_FREQUENCY_FORM.YEARLY' | translate }}
    </mat-option>
  </mat-select>
</glxy-form-field>
